
import "es6-promise";

import get from "lodash-es/get";
import sortBy from "lodash-es/sortBy";

import Vue, { ComponentOptions } from "vue";
import Component from "vue-class-component";
import {
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Watch
} from "vue-property-decorator";

@Component({
  components: {},
  props: {},
  filters: {}
})
export default class MainSidenav extends Vue {
  @Prop({ default: false, type: Boolean })
  showJobsLink: boolean;

  get availablePipelines() {
    return sortBy(
      this.$store.state.availablePipelines,
      p => !get(p, "public", true)
    );
  }

  getPipelineShortDescription(name: string) {
    return get(
      this.$store.state.availablePipelines[name],
      "metadata.short_description",
      name
    );
  }

  routeTo(name: string, params: any = {}) {
    this.$router.push({ name: name, params: params });
  }
  toggle(refName: string) {
    ((this.$refs as any)["sidenav"] as any).toggle();
  }
  open(ref: string) {
    // console.log('Opened: ' + ref);
  }
  close(ref: string) {
    // console.log('Closed: ' + ref);
  }
}
